import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import MKBox from "components/MKBox";

export default function FadeIn({ children, show, timeout = 400, sx }) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (show) {
      const t = setTimeout(() => setVisible(true), 50);
      return () => clearTimeout(t);
    }
    setVisible(false);
  }, [show]);

  return (
    <MKBox
      sx={{
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(8px)",
        transition: `opacity ${timeout}ms ease, transform ${timeout}ms ease`,
        ...sx,
      }}
    >
      {children}
    </MKBox>
  );
}

FadeIn.propTypes = { children: PropTypes.node, show: PropTypes.bool, timeout: PropTypes.number, sx: PropTypes.object };
